import { render, staticRenderFns } from "./XTable.vue?vue&type=template&id=de37ad90&scoped=true"
import script from "./XTable.vue?vue&type=script&lang=js"
export * from "./XTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de37ad90",
  null
  
)

export default component.exports